import { render, staticRenderFns } from "./signupInstructions.vue?vue&type=template&id=543497c0&scoped=true&"
import script from "./signupInstructions.vue?vue&type=script&lang=js&"
export * from "./signupInstructions.vue?vue&type=script&lang=js&"
import style0 from "./signupInstructions.vue?vue&type=style&index=0&id=543497c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543497c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543497c0')) {
      api.createRecord('543497c0', component.options)
    } else {
      api.reload('543497c0', component.options)
    }
    module.hot.accept("./signupInstructions.vue?vue&type=template&id=543497c0&scoped=true&", function () {
      api.rerender('543497c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/signup/partials/signupInstructions.vue"
export default component.exports